/* eslint-disable prefer-destructuring */
import React from "react"

import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"

import * as styles from "./feed.module.scss"
import CardMapping from "../../../helpers/card-mapping"
import Grid from "../../atoms/grid"
import Heading from "../../atoms/heading"
import StickyIntro from "../../atoms/sticky-intro"
import Wrapper from "../../atoms/wrapper"
import Card from "../../molecules/card"
import Pagination from "../../molecules/pagination"
import Podcast from "../../molecules/podcast"
import SidebarItem from "../../molecules/sidebar-item"
import Testimonials from "../../molecules/testimonials"
import Sidebar from "../sidebar"

const Feed = ({
  stories,
  prevPage,
  nextPage,
  featuredArticles,
  color,
  sidebar,
  type,
  testimonials,
  podcasts,
  basic,
}) => {
  const { allSanityDictionary } = useStaticQuery(graphql`
    {
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
    }
  `)
  const firstFeaturedArticle = featuredArticles[0] || stories[0]
  const firstSet = featuredArticles[0]
    ? stories.slice(0, 3)
    : stories.slice(1, 4)
  const secondSet = featuredArticles[0]
    ? stories.slice(3, 6)
    : stories.slice(4, 7)
  let secondFeaturedArticle = featuredArticles[1]
  let rest = []
  if (!basic) {
    rest = stories.slice(6, 12)
    if (!prevPage) {
      if (featuredArticles[0] && !featuredArticles[1]) {
        secondFeaturedArticle = stories[6]
        rest = stories.slice(7, 13)
      } else if (!featuredArticles[0] && !featuredArticles[1]) {
        secondFeaturedArticle = stories[7]
        rest = stories.slice(8)
      }
    }
  }

  const mainGrid = (cards, isTitled) => (
    <Wrapper container>
      {isTitled ? (
        <Heading level="2">
          {
            allSanityDictionary.nodes.find(
              (item) => item.key.current === "continue_reading"
            )?.value
          }
        </Heading>
      ) : (
        ""
      )}
      <Grid col={3}>
        {cards.map((item) => (
          <div key={item.id}>
            <Card article={item} variant={basic ? "labelled" : null} />
          </div>
        ))}
      </Grid>
    </Wrapper>
  )

  return (
    <div>
      {prevPage || stories.length < 9 || basic ? (
        mainGrid(stories, basic && !prevPage)
      ) : (
        <>
          <Wrapper container>
            <Grid col={2}>
              <StickyIntro>
                <Card
                  variant="secondary_feature"
                  article={CardMapping(
                    firstFeaturedArticle,
                    allSanityDictionary.nodes
                  )}
                  color={color}
                />
              </StickyIntro>
              <div className={styles.spacer}>
                {firstSet.map((item) => (
                  <div key={item.id}>
                    <Card variant="tertiary_feature" article={item} />
                  </div>
                ))}
              </div>
            </Grid>
            <Grid col={3}>
              {secondSet.map((item) => (
                <div key={item.id}>
                  <Card article={item} />
                </div>
              ))}
            </Grid>
            <Grid col={1}>
              <div>
                <div>
                  <Card
                    variant="primary_feature"
                    article={CardMapping(
                      secondFeaturedArticle,
                      allSanityDictionary.nodes
                    )}
                    color={color || secondFeaturedArticle.sport?.color}
                  />
                </div>
              </div>
            </Grid>
            {podcasts.length > 0 ? (
              <div className={styles.podcasts}>
                <Podcast podcast={podcasts[0]} feed />
                <Grid col={4}>
                  {podcasts.slice(1, 5).map((podcast) => (
                    <div key={podcast.id}>
                      <SidebarItem item={podcast} />
                    </div>
                  ))}
                </Grid>
              </div>
            ) : (
              ""
            )}
          </Wrapper>
          <Sidebar
            sidebar={sidebar}
            color={color}
            title={type === "home" ? "guides_glossaries_faqs" : "learn_more"}
            secondaryTitle={type !== "home" ? type : ""}
          />
        </>
      )}
      {testimonials ? <Testimonials /> : ""}
      {!prevPage && rest.length > 0 ? mainGrid(rest, true) : ""}
      <Wrapper container>
        <Pagination prevPage={prevPage} nextPage={nextPage} />
      </Wrapper>
    </div>
  )
}

export default Feed

Feed.propTypes = {
  stories: PropTypes.array.isRequired,
  prevPage: PropTypes.string,
  nextPage: PropTypes.string,
  featuredArticles: PropTypes.array,
  color: PropTypes.string,
  sidebar: PropTypes.array,
  type: PropTypes.string,
  testimonials: PropTypes.bool,
  podcasts: PropTypes.array,
  basic: PropTypes.bool,
}

Feed.defaultProps = {
  basic: false,
  prevPage: "",
  nextPage: "",
  featuredArticles: [],
  color: "",
  sidebar: [],
  type: "",
  testimonials: false,
  podcasts: [],
}
